var _path, _g, _path2, _path3, _rect, _path4, _rect2, _path5, _rect3, _path6, _rect4, _g2, _rect5, _path7, _rect6, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepbystep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "stepbystep",
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M48,0A48,48,0,1,1,0,48,48,48,0,0,1,48,0Z",
    transform: "translate(0 0)",
    fill: "#b0c2c4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396",
    transform: "translate(9.9 2.55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_525",
    "data-name": "Rectangle 525",
    width: 3,
    height: 3,
    transform: "translate(55.05 34.65)",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_526",
    "data-name": "Rectangle 526",
    width: 3,
    height: 3,
    transform: "translate(64.2 34.65)",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_527",
    "data-name": "Rectangle 527",
    width: 3,
    height: 3,
    transform: "translate(73.2 34.65)",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_528",
    "data-name": "Rectangle 528",
    width: 3,
    height: 3,
    transform: "translate(0 53.25)",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_529",
    "data-name": "Rectangle 529",
    width: 3,
    height: 3,
    transform: "translate(9 53.25)",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_530",
    "data-name": "Rectangle 530",
    width: 3,
    height: 3,
    transform: "translate(18.15 53.25)",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M137.583,23.291l-2.1-2.1,2.7-2.85-2.7-2.85,2.1-2.1,4.95,4.95Z",
    transform: "translate(-119.583 -13.391)",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_531",
    "data-name": "Rectangle 531",
    width: 9.3,
    height: 3,
    transform: "translate(11.4 3.45)",
    fill: "#183651"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M0,0H19.8V12.15H0Z",
    transform: "translate(38.1 82.35)",
    fill: "#8bc400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M213.5,439.716H193.7a1.417,1.417,0,0,1-1.5-1.5v-12.15a1.417,1.417,0,0,1,1.5-1.5h19.8a1.417,1.417,0,0,1,1.5,1.5v12.15A1.417,1.417,0,0,1,213.5,439.716Zm-18.3-3H212v-9.15H195.2Z",
    transform: "translate(-155.597 -343.716)",
    fill: "#183651"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_533",
    "data-name": "Rectangle 533",
    width: 19.8,
    height: 12.15,
    transform: "translate(38.1 62.1)",
    fill: "#e0e4e8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M213.5,333.378H193.7a1.417,1.417,0,0,1-1.5-1.5v-12.15a1.417,1.417,0,0,1,1.5-1.5h19.8a1.417,1.417,0,0,1,1.5,1.5v12.15A1.417,1.417,0,0,1,213.5,333.378Zm-18.3-3H212v-9.15H195.2Z",
    transform: "translate(-155.597 -257.628)",
    fill: "#183651"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_534",
    "data-name": "Rectangle 534",
    width: 19.8,
    height: 12.15,
    transform: "translate(38.1 42)",
    fill: "#8bc400"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M213.5,227.039H193.7a1.417,1.417,0,0,1-1.5-1.5v-12.15a1.417,1.417,0,0,1,1.5-1.5h19.8a1.417,1.417,0,0,1,1.5,1.5v12.15A1.417,1.417,0,0,1,213.5,227.039Zm-18.3-3H212v-9.15H195.2Z",
    transform: "translate(-155.597 -171.539)",
    fill: "#183651"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_535",
    "data-name": "Rectangle 535",
    width: 19.8,
    height: 12.15,
    transform: "translate(38.1 21.75)",
    fill: "#e0e4e8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M213.5,121.488H193.7a1.417,1.417,0,0,1-1.5-1.5v-12.15a1.417,1.417,0,0,1,1.5-1.5h19.8a1.417,1.417,0,0,1,1.5,1.5v12.15A1.5,1.5,0,0,1,213.5,121.488Zm-18.3-3H212v-9.15H195.2Z",
    transform: "translate(-155.597 -86.088)",
    fill: "#183651"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_536",
    "data-name": "Rectangle 536",
    width: 19.8,
    height: 12.15,
    transform: "translate(38.1 1.5)",
    fill: "#8bc400"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397",
    transform: "translate(1.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M213.5,15.15H193.7a1.417,1.417,0,0,1-1.5-1.5V1.5A1.417,1.417,0,0,1,193.7,0h19.8A1.417,1.417,0,0,1,215,1.5V13.65A1.5,1.5,0,0,1,213.5,15.15Zm-18.3-3H212V3H195.2Z",
    transform: "translate(-156.647)",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M329.78,446.132l-2.1-2.1,2.7-2.7-2.7-2.85,2.1-2.1,4.8,4.95Z",
    transform: "translate(-266.33 -353.282)",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_537",
    "data-name": "Rectangle 537",
    width: 9.3,
    height: 3,
    transform: "translate(56.85 86.55)",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M143.247,442.343l-2.25-2.1,2.85-2.85-2.85-2.85,2.25-2.1,4.8,4.95Z",
    transform: "translate(-115.197 -350.093)",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M36.114,372.573h-19.5a11.026,11.026,0,1,1,.15-22.05h25.8v3h-25.8a8.1,8.1,0,0,0,0,16.2h19.5v2.85h-.15Z",
    transform: "translate(-5.514 -283.773)",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M143.247,230.3,141,228.2l2.85-2.7-2.85-2.85,2.25-2.1,4.8,4.95Z",
    transform: "translate(-115.197 -178.554)",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M36.114,160.047h-19.5a11.075,11.075,0,0,1-11.1-11.1,11.2,11.2,0,0,1,11.25-11.1h25.8v3h-25.8a8.1,8.1,0,0,0,0,16.2h19.5v3h-.15Z",
    transform: "translate(-5.514 -111.597)",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M330.9,340.581l-4.8-4.95,4.8-4.8,2.25,2.1-2.85,2.7,2.85,2.85Z",
    transform: "translate(-265.055 -267.831)",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M329.849,266.348h-19.5v-3h19.5a8.066,8.066,0,0,0,8.1-8.1v-.75a8.066,8.066,0,0,0-8.1-8.1h-25.8v-3h25.8a11.075,11.075,0,0,1,11.1,11.1v.75A11.075,11.075,0,0,1,329.849,266.348Z",
    transform: "translate(-247.199 -197.048)",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M330.9,128.054l-4.8-4.95,4.8-4.95,2.25,2.1-2.85,2.85,2.85,2.85Z",
    transform: "translate(-265.055 -95.654)",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M329.849,54.458h-19.5v-3h19.5a8.066,8.066,0,0,0,8.1-8.1v-.75a8.066,8.066,0,0,0-8.1-8.1h-25.8v-3h25.8a11.075,11.075,0,0,1,11.1,11.1v.75A11.075,11.075,0,0,1,329.849,54.458Z",
    transform: "translate(-247.199 -25.508)",
    fill: "#183651"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_538",
    "data-name": "Rectangle 538",
    width: 19.8,
    height: 12.15,
    transform: "translate(74.7 82.35)",
    fill: "#aaa"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M405.694,439.716h-19.8a1.417,1.417,0,0,1-1.5-1.5v-12.15a1.417,1.417,0,0,1,1.5-1.5h19.8a1.417,1.417,0,0,1,1.5,1.5v12.15A1.417,1.417,0,0,1,405.694,439.716Zm-18.3-3h16.8v-9.15h-16.8Z",
    transform: "translate(-311.194 -343.716)",
    fill: "#183651"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_539",
    "data-name": "Rectangle 539",
    width: 19.8,
    height: 12.15,
    transform: "translate(1.5 1.5)",
    fill: "#aaa"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M21.3,15.15H1.5A1.417,1.417,0,0,1,0,13.65V1.5A1.417,1.417,0,0,1,1.5,0H21.3a1.417,1.417,0,0,1,1.5,1.5V13.65A1.5,1.5,0,0,1,21.3,15.15ZM3,12.15H19.8V3H3Z",
    fill: "#183651"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepbystep);
export default __webpack_public_path__ + "static/media/stepbystep.ec2c0a2f44301b511abd57339e704e11.svg";
export { ForwardRef as ReactComponent };